module.exports = __webpack_public_path__ + "img/Medication Safety.9b07a600.jpg";